<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />
    Thank you for your quick response. We are pleased to hear you can
    participate.<br />
    Please see the attached case files in preparation for the interview. We will
    reach out to your secrertary to schedule a time.<br /><br /><br />

    Sincerely,<br />
    City Police Portland, Oregon<br /><br />

    On Tue, Aug 5, 2022 at 12:30 PM A. Jones &lt;<a
      href="mailto:a.jones@atcl.com"
      >a.jones@atcl.com</a
    >&gt; wrote:<br />

    > Sure, happy to help. Please liaise with Anand, my secretary at
    a.amin@atcl.com to arrange a time in the week after my vacation.<br />
    ><br />
    ><br />
    > A. Jones<br />
    ><br />
    > <b>From:</b> City Police Portland &lt;<a
      href="mailto:ccpo.lhr.police.gov@gmail.com"
      >ccpo.lhr.police.gov@gmail.com</a
    >&gt; <br />
    > <b>Sent:</b> Tuesday, Aug 5, 2022 12:18 PM <br />
    > <b>To: A Jones</b> &lt;<a href="mailto:a.jones@atcl.com"
      >a.jones@atcl.com</a
    >&gt;<br />
    > <b>Subject:</b> Important request for interview<br />
    > <br />
    > Dear A. Jones,<br />
    > <br/>
    > I am writing you on behalf of the Portland City Police Department
    investigating potential crime related to the 5G network ATCL is planning to
    build.<br />
    > To this end, we would like to invite you to a private interview to
    understand ATCL's awareness and decision-making process on the matters
    raised by our Portland community.<br />
    > Please let us know if you are available to participate.<br/>
    > <br/>
    > <br/>
    > Sincerely,<br />
    > City Police Portland, Oregon<br /><br />
    <div class="email-attachment">
      <div class="attachment-icon"></div>
      <div class="attachment-details">
        <p class="attachment-filename">case-234981.zip</p>
      </div>
      <a
        @click="
          parentFunction('https://www.dropbox.com/scl/fi/47qymdypwzgcpzvlmnm5y/case-234981.zip?rlkey=3z2r6aiy1z0loy6u9hm284oyj&st=3mc7mk6l&dl=1')
        "
        class="download-link"
        target="_blank"
        href="https://www.dropbox.com/scl/fi/47qymdypwzgcpzvlmnm5y/case-234981.zip?rlkey=3z2r6aiy1z0loy6u9hm284oyj&st=3mc7mk6l&dl=1"
        >Download</a
      >
    </div>
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
